// libraries
import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = makeStyles({
  input: {
    "&:before": {
      borderBottom: 0,
    },
  },
});
